import {
    withStyles,
    Tooltip
} from '@material-ui/core';

export const CustomTooltip = withStyles({
    tooltip: {
      color: "#606060",
      backgroundColor: "#fff",
      border: "1px solid #606060",
      fontSize: "12px",
      fontFamily: "Catalana-sans",
      borderRadius: "0px",
    }
})(Tooltip);